import { render } from "./LabelField.vue?vue&type=template&id=1317c492"
import script from "./LabelField.vue?vue&type=script&lang=js"
export * from "./LabelField.vue?vue&type=script&lang=js"

import "./LabelField.vue?vue&type=style&index=0&id=1317c492&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__